import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import { snakeUppercase } from "@Shared/@Utils/utils";
import { clone, cloneDeep, isEmpty } from "lodash";
export const DEFAULTSUBSTITUTIONSTAGS = {
  FIRST_NAME: "FIRST_NAME",
  LAST_NAME: "LAST_NAME",
  REF_FIRST_NAME: "REF_FIRST_NAME",
  REF_LAST_NAME: "REF_LAST_NAME"
};
export const getOrphanCustomFields = (customFields = [], customFieldsDefinitions) => {
  return _reduceInstanceProperty(customFields).call(customFields, (acc, field) => {
    const customFieldsDefinition = customFieldsDefinitions == null ? void 0 : customFieldsDefinitions.byId[field.id];
    const isOrphanField = field.id && isEmpty(customFieldsDefinition) && field.type !== "dropdown";
    if (isOrphanField) {
      acc.push(_objectSpread(_objectSpread({}, field), {}, {
        orphaned: true
      }));
    }
    return acc;
  }, []);
};
export const mergeCustomFields = (customFields = [], customFieldsDefinitions) => {
  var _context;
  return _mapInstanceProperty(_context = customFieldsDefinitions.allIds).call(_context, definitionId => {
    var _customFieldData$id;
    const definition = customFieldsDefinitions == null ? void 0 : customFieldsDefinitions.byId[definitionId];
    const customFieldData = _findInstanceProperty(customFields).call(customFields, ({
      id,
      name
    }) => id === null ? name === definition.name : id === definitionId);
    const idToUse = (_customFieldData$id = customFieldData == null ? void 0 : customFieldData.id) != null ? _customFieldData$id : definition.id;
    return {
      id: idToUse,
      name: definition.name,
      type: definition.type,
      value: (customFieldData == null ? void 0 : customFieldData.value) || null
    };
  });
};
export const replaceSubstitutionsTags = (body, detailsForSubstitution) => {
  let newBody = clone(body);
  detailsForSubstitution.forEach(({
    name,
    value
  }) => {
    newBody = _replaceAllInstanceProperty(newBody).call(newBody, `{{${snakeUppercase(name)}}}`, value);
  });
  return newBody;
};
export const getSubstitutionsNamesInfo = profileDetails => {
  return [{
    name: DEFAULTSUBSTITUTIONSTAGS.FIRST_NAME.toLowerCase(),
    value: profileDetails.givenName
  }, {
    name: DEFAULTSUBSTITUTIONSTAGS.LAST_NAME.toLowerCase(),
    value: profileDetails.familyName
  }];
};
export const setCustomFieldsValues = (customFields = [], customFieldDefinitions) => {
  var _context2;
  const orphanedFieldsIds = _mapInstanceProperty(_context2 = getOrphanCustomFields(customFields, customFieldDefinitions)).call(_context2, ({
    id
  }) => id);
  const {
    allIds: customFieldsIds
  } = cloneDeep(customFieldDefinitions);
  const allCustomFieldsIds = [...customFieldsIds, ...orphanedFieldsIds];
  return _mapInstanceProperty(allCustomFieldsIds).call(allCustomFieldsIds, customFieldId => {
    const currentCustomField = _findInstanceProperty(customFields).call(customFields, customField => customField.id === customFieldId);
    if ((currentCustomField == null ? void 0 : currentCustomField.type) === "address") return _objectSpread(_objectSpread({}, currentCustomField), {}, {
      value: !isEmpty(currentCustomField == null ? void 0 : currentCustomField.value) ? currentCustomField == null ? void 0 : currentCustomField.value["formatted-address"] : ""
    });
    if ((currentCustomField == null ? void 0 : currentCustomField.type) === "dropdown") {
      var _options$items$find$n, _options$items$find, _context3;
      const {
        options
      } = customFieldDefinitions.byId[customFieldId];
      return _objectSpread(_objectSpread({}, currentCustomField), {}, {
        value: (_options$items$find$n = options == null ? void 0 : (_options$items$find = _findInstanceProperty(_context3 = options.items).call(_context3, item => item.id === (currentCustomField == null ? void 0 : currentCustomField.value))) == null ? void 0 : _options$items$find.name) != null ? _options$items$find$n : ""
      });
    }
    return _objectSpread(_objectSpread({}, currentCustomField), {}, {
      value: (currentCustomField == null ? void 0 : currentCustomField.value) || ""
    });
  });
};